import { render, staticRenderFns } from "./CancellationForm.vue?vue&type=template&id=c0b3051e&"
import script from "./CancellationForm.vue?vue&type=script&lang=js&"
export * from "./CancellationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports